"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = exports.SectionDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
;
exports.SectionDefaultProps = {
  space: 'both',
  titleSpace: 'both',
  iconSize: 24,
  titleColor: 'textMid',
  divider: true
};
// --------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    font-size: ", ";\n    background-position: top left;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "], ["\n    ", "\n    font-size: ", ";\n    background-position: top left;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "])), function (props) {
    return props.backgroundColor && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme_1.theme.COLOR(props.backgroundColor));
  }, theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(4))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", "em;\n    margin-top: 0;\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    /* ", "; */\n    background-position: top left;\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n  "], ["\n    font-size: ", "em;\n    margin-top: 0;\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    /* ", "; */\n    background-position: top left;\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n  "])), 15 / 14, theme_1.theme.FONT('heading'), theme_1.theme.DOT_BG('h', 'line-mid', 2, 4), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR('dark'));
  }, function (props) {
    return props.divider && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border-top: 1px solid ", ";\n    "], ["\n      border-top: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-semi-subtle'));
  }, function (props) {
    return (props.space === 'both' || props.space === 'v') && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding-top: 14px;\n    "], ["\n      padding-top: 14px;\n    "])));
  }, function (props) {
    return (props.space === 'both' || props.space === 'h') && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3));
  })
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (props) {
    return (props.space === 'both' || props.space === 'v') && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding-top: ", ";\n    "], ["\n      padding-top: ", ";\n    "])), theme_1.theme.UNIT(3));
  }, function (props) {
    return (props.space === 'both' || props.space === 'h') && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 100%;\n    margin: 0 auto;\n    box-sizing: border-box;\n  "], ["\n    width: 100%;\n    margin: 0 auto;\n    box-sizing: border-box;\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.h1(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Content: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
var Section = function (props) {
  var className = props.className,
    children = props.children,
    controls = props.controls,
    title = props.title,
    backgroundColor = props.backgroundColor,
    space = props.space,
    titleColor = props.titleColor,
    titleSpace = props.titleSpace,
    id = props.id,
    iconSize = props.iconSize,
    divider = props.divider;
  var Icon = props.icon;
  var hasHeader = !!controls || !!title;
  return React.createElement(My.Container, {
    backgroundColor: backgroundColor,
    id: id,
    className: className
  }, React.createElement(My.Body, null, hasHeader && React.createElement(My.Header, null, title && React.createElement(My.Title, {
    titleColor: titleColor,
    space: titleSpace || space
  }, Icon && React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icon, null)), title, ":"), controls), React.createElement(My.Content, {
    space: space
  }, children)));
};
exports.Section = Section;
exports.Section.defaultProps = exports.SectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;